import React, { useReducer, useEffect, useContext } from "react";
import documentoContext from "./documentosContex";
import {getAllDocumentos,addDocumento,updateDocumento,deleteDocumento} from "../../api/documento";
import documentoReducer from "./documentosReducer";

//Types
import { 
    ACTUALIZAR_LIST_DOCUMENTO,
  } from "./documentosActions";

  import authContext from '../authentication/authContex'
import Swal from "sweetalert2";

const DocumentoState = props =>{
     
    const initialState = {
        documentosList: null
    };

    const [state, dispatch] = useReducer(documentoReducer, initialState);
    const {usuario} = useContext(authContext);

    const actualizarDocumentoList = async () => {
        try{
            const resp = await getAllDocumentos();
            const documento = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_DOCUMENTO,
                payload: documento
            });
            
            return documento;
        }catch(err){
            console.log(err)
        }

    };

    const getDocumentoByCodDocumento = async (codDocumento) => {
        try {
            /*
            const resp = await  getByCodDocumento(codDocumento);
            const documento = resp.data.data;
            return documento;
            */
        } catch(err){
            console.log(err)
        }
    }

    const agregarDocumento = async (documento) => {
        try{
            let res = await addDocumento(documento)
            if(res.data.docCreated != undefined){
                actualizarDocumentoList();
                return res.data.docCreated;
            }
        }catch(err){
            console.log(err);
            return err.response.data;
        }
    };
    
    //-------------- Modificar Documentos --------------------------------------------------------------------
    const modificarDocumento = async (doc) => {
        try {
            const res = await updateDocumento(doc);
            if(res.data.docUpdated != undefined){
                actualizarDocumentoList();
                return res.data.docUpdated;
            }
        } catch (err) {
            return err;
        }
    }
    
    //------------------------------------------------------------------------------------------------

    const eliminarDocumento = async (idDoc) => {
        
        try{
            //Solo requiere el id del documento a eliminar.
            const res = await deleteDocumento(idDoc);
            if(res.data.deleted){
                actualizarDocumentoList();
            }else if(res.data.msgError){
                Swal.fire({
                    title:'Imposible borrar documento!',
                    text: res.data.msgError,
                    icon:'error'
                })
                return false;
            }
            return res.data.deleted;
        }catch(err){
            console.log(err)
        }
    }

    const actualizarDocumentosXactivoList = async() => {
        try {
            
        } catch (error) {
            
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarDocumentoList();
    },[usuario])

    return(
        <documentoContext.Provider
            value={{
                documentosList: state.documentosList,
                actualizarDocumentoList,
                getDocumentoByCodDocumento,
                agregarDocumento,
                modificarDocumento,
                eliminarDocumento,
            }}
        >
            {props.children}
        </documentoContext.Provider>
    )

}

export default DocumentoState;